export class UserCredentials
{
    email:string;
    password: string;
    refreshToken:string;
    isBusinessActive: boolean;
}